import React, { useEffect, useRef, useState } from "react";
import Confetti from "react-confetti";
import styled, { css } from "styled-components";
import useOnClickOutside from "../../hooks/useOnClickOutside";

// import '../../css/confetti.css';
// import '../../components/advance/Confetti'

const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: ${(props) => (props?.style?.bottom ? props?.style?.bottom : 0 || 0)};
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  ${'' /* ${(props) => // console.log(props)} */}
  ${'' /* ${(props) => // console.log(props?.alignItems)} */}
  justify-content: ${(props) =>
    props?.justifyContent ? props?.justifyContent : "center" || "center"};
  align-items: ${(props) =>
    props?.alignItems ? props?.alignItems : "center" || "center"};
  z-index: 10;
  ${"" /* background-color: red; */}
  & > .modal-content {
    padding: 1.5rem 2rem;
    background-color: white;
    border-radius: 5px;
    width: fit-content;
    position: relative;
    margin-left: 15px;
    margin-right: 15px;
    border-radius: ${(props) => props?.style?.borderRadius ?? "5px"};
    ${(props) =>
      (props?.style?.borderTopLeftRadius !== undefined) &
      css`
        border-top-left-radius: ${props?.style?.borderTopLeftRadius};
        border-top-right-radius: ${props?.style?.borderTopRightRadius};
      `};
    background-color: ${(props) => props?.style?.backgroundColor ?? "white"};
    .close-button {
      position: absolute;
      top: 0;
      right: 0;
      background-color: transparent;
      border-top-right-radius: 5px;
      height: 3.2rem;
      width: 3.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      img {
        height: 1.6rem;
        width: 1.6rem;
      }
    }

    .closeIcon {
      ${
        "" /* position: absolute;
            right: 32px;
            top: 32px; */
      }
      width: 32px;
      height: 32px;
      opacity: 0.3;
    }
    .closeIcon:hover {
      opacity: 1;
    }
    .closeIcon:before,
    .closeIcon:after {
      position: absolute;
      left: 10px;
      top: 10px;
      content: " ";
      height: 20px;
      width: 2px;
      background-color: #000;
    }
    .closeIcon:before {
      transform: rotate(45deg);
    }
    .closeIcon:after {
      transform: rotate(-45deg);
    }

    @media screen and (min-width: 760px) {
      width: fit-content;
      margin: 1rem;
    }
  }
`;

const StyledConfetti = styled(Confetti)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 11;
  opacity: ${(props) => (props.fadeOut ? 0 : 1)};
  transition: opacity 3s ease-out;
`;

const Modal = ({
  open = false,
  onClose,
  isConfetti = false,
  closeOnClickOutside = true,
  children,
  showCloseButton = false,
  closeButtonStyle = undefined,
  id = "modal-parent",
  className = undefined,
  modalStyle = undefined,
  style = undefined,
  ...props
}) => {
  const enhanchedChildren = React.Children.map(children, (child) =>
    React.cloneElement(child, {
      onClose,
    })
  );
  const ref = useRef();
  useOnClickOutside(ref, () => {
    if (closeOnClickOutside) onClose();
  });
  const [showConfetti, setShowConfetti] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (open) {
      document.body.style.overflowX = "hidden";
      document.body.style.overflowY = "hidden";
      if (isConfetti) {
        setShowConfetti(true);
        setTimeout(() => {
          setFadeOut(true);
        }, 3000);
        setTimeout(() => {
          setShowConfetti(false);
        }, 6000);
      }
    } else {
      document.body.style.overflowX = "hidden";
      document.body.style.overflowY = "auto";
      setShowConfetti(false);
      setFadeOut(false);
    }
  }, [open, isConfetti]);

  className =
    className === undefined ? "modal-content" : "modal-content " + className;
  return open ? (
    <StyledModal onClick={(e) => e.stopPropagation()} {...style}>
      <div id={id} ref={ref} className={className} style={{ ...modalStyle }}>
        {showConfetti && <StyledConfetti fadeOut={fadeOut} />}
        {enhanchedChildren}
        {showCloseButton && (
          <div
            onClick={onClose}
            className="close-button"
            style={{ ...closeButtonStyle }}
          >
            <div className="closeIcon"></div>
          </div>
        )}
      </div>
    </StyledModal>
  ) : null;
};

export default Modal;
